export default "__VITE_ASSET__D6B5AXI2__"